import { orchestrator } from 'satcheljs';
import { logUsage as logUsageAction } from 'owa-analytics-actions';
import { logUsage } from '../api/logUsage';

orchestrator(logUsageAction, actionMessage => {
    logUsage(actionMessage.eventName, actionMessage.customData, actionMessage.options).catch(() => {
        // If this fails, then can lead to an infinite loop as this failure will usually be logged as a datapoint
    });
});
